import {
  TRANSACTION_FETCH_REQUEST,
  TRANSACTION_FETCH_REQUEST_SUCCESS,
  TRANSACTION_FETCH_REQUEST_FAILURE,
  TRANSACTION_CLEAN_REQUEST,
  TRANSACTION_DASHBOARD_FETCH_REQUEST_SUCCESS,
  TODAY_TRANSACTION_FETCH_REQUEST,
  TODAY_TRANSACTION_FETCH_REQUEST_SUCCESS,
  TODAY_TRANSACTION_FETCH_REQUEST_FAILURE,
  TODAY_TRANSACTION_CLEAN_REQUEST,
  MONTHLY_TRANSACTION_FETCH_REQUEST,
  MONTHLY_TRANSACTION_FETCH_REQUEST_SUCCESS,
  MONTHLY_TRANSACTION_FETCH_REQUEST_FAILURE,
  MONTHLY_TRANSACTION_CLEAN_REQUEST,
  ALL_TRANSACTION_FETCH_REQUEST,
  ALL_TRANSACTION_FETCH_REQUEST_SUCCESS,
  ALL_TRANSACTION_FETCH_REQUEST_FAILURE,
  ALL_TRANSACTION_CLEAN_REQUEST,
  WATCHLIST_TRANSACTION_FETCH_REQUEST,
  WATCHLIST_TRANSACTION_FETCH_REQUEST_SUCCESS,
  WATCHLIST_TRANSACTION_FETCH_REQUEST_FAILURE,
  WATCHLIST_TRANSACTION_CLEAN_REQUEST,
  TRANSACTION_PAYMENT_FETCH_REQUEST,
  TRANSACTION_PAYMENT_FETCH_REQUEST_SUCCESS,
  TRANSACTION_PAYMENT_FETCH_REQUEST_FAILURE,
  TRANSACTION_PAYMENT_CLEAN_REQUEST,
  TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST,
  TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_SUCCESS,
  TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_FAILURE,
  TRANSACTION_HIT_COUNT_LIST_CLEAN_REQUEST,
  TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST,
  TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_SUCCESS,
  TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_FAILURE,
  TXN_COUNT_AMOUNT_SUMMARY_CLEAN_REQUEST,
  MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST,
  MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS,
  MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE,
  MONTHLY_TXN_COUNT_AMOUNT_CLEAN_REQUEST,
  ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST,
  ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS,
  ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE,
  ALL_TXN_COUNT_AMOUNT_CLEAN_REQUEST,
  TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST,
  TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS,
  TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE,
  TODAY_TXN_COUNT_AMOUNT_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  totalApprovedAmounts: [],
  totalApprovedCount: '',
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const TODAY_TXN_INITIAL_STATE = {
  todayTxnPayload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const MONTHLY_TXN_INITIAL_STATE = {
  monthlyTxnPayload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const ALL_TXN_INITIAL_STATE = {
  allTxnPayload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const WATCHLIST_TXN_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const PAYMENT_TXN_INITIAL_STATE = {
  paymentPayload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const HITCOUNT_TXN_INITIAL_STATE = {
  summaryPayload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const TODAY_TXN_COUNT_AMOUNT_INITIAL_AMOUNT = {
  todayPayload: [],
  loading: false,
  errors: {},
};
const MONTHLY_TXN_COUNT_AMOUNT_INITIAL_AMOUNT = {
  monthlyPayload: [],
  loading: false,
  errors: {},
};
const ALL_TXN_COUNT_AMOUNT_INITIAL_AMOUNT = {
  allPayload: [],
  loading: false,
  errors: {},
};
const TXN_COUNT_AMOUNT_SUMMARY_INITIAL_AMOUNT = {
  payload: [],
  loading: false,
  errors: {},
};
/**
 * A reducer takes two arguments, the current state and an action.
 */
export const transactionReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        totalApprovedAmounts: action.data.totalApprovedAmounts || 0,
        totalApprovedCount: action.data.totalApprovedCount || 0,
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case TRANSACTION_DASHBOARD_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data.data || action.data,
        errors: {},
        totalApprovedAmounts: action.data.totalApprovedAmounts || 0,
        totalApprovedCount: action.data.totalApprovedCount || 0,
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
        totalApprovedAmounts: [],
        totalApprovedCount: '',
      });

    default:
      return state;
  }
};

//today txn reducer
export const todaytransactionReducer = (state, action) => {
  state = state || TODAY_TXN_INITIAL_STATE;

  switch (action.type) {
    case TODAY_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TODAY_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case TODAY_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TODAY_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};
//monthly txn reducer
export const monthlytransactionReducer = (state, action) => {
  state = state || MONTHLY_TXN_INITIAL_STATE;

  switch (action.type) {
    case MONTHLY_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MONTHLY_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case MONTHLY_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MONTHLY_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

//All txn

export const allTransactionReducer = (state, action) => {
  state = state || ALL_TXN_INITIAL_STATE;

  switch (action.type) {
    case ALL_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ALL_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload:
          action.data.currentPage > 1
            ? [...state.payload, ...action.data.data]
            : [...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case ALL_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ALL_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

//hit count/summary txn

export const hitCountTransactionReducer = (state, action) => {
  state = state || HITCOUNT_TXN_INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          // pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case TRANSACTION_HIT_COUNT_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_HIT_COUNT_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};
//payment request txn
export const transactionPaymentReducer = (state, action) => {
  state = state || PAYMENT_TXN_INITIAL_STATE;

  switch (action.type) {
    case TRANSACTION_PAYMENT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TRANSACTION_PAYMENT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,

          showSizeChanger: true,
        },
      });

    case TRANSACTION_PAYMENT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TRANSACTION_PAYMENT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

//watchList txn
export const watchListTransactionReducer = (state, action) => {
  state = state || WATCHLIST_TXN_INITIAL_STATE;

  switch (action.type) {
    case WATCHLIST_TRANSACTION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case WATCHLIST_TRANSACTION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,

          showSizeChanger: true,
        },
      });

    case WATCHLIST_TRANSACTION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case WATCHLIST_TRANSACTION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {},
      });

    default:
      return state;
  }
};

//today txn CountAmount
export const todayCountAmountTransactionReducer = (state, action) => {
  state = state || TODAY_TXN_COUNT_AMOUNT_INITIAL_AMOUNT;

  switch (action.type) {
    case TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TODAY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TODAY_TXN_COUNT_AMOUNT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

//monthly txn CountAmount
export const monthlyCountAmountTransactionReducer = (state, action) => {
  state = state || MONTHLY_TXN_COUNT_AMOUNT_INITIAL_AMOUNT;

  switch (action.type) {
    case MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case MONTHLY_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MONTHLY_TXN_COUNT_AMOUNT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

//alll txn CountAmount
export const allCountAmountTransactionReducer = (state, action) => {
  state = state || ALL_TXN_COUNT_AMOUNT_INITIAL_AMOUNT;

  switch (action.type) {
    case ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case ALL_TXN_COUNT_AMOUNT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case ALL_TXN_COUNT_AMOUNT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
//txn CountAmount summary
export const countAmountTransactionSummaryReducer = (state, action) => {
  state = state || TXN_COUNT_AMOUNT_SUMMARY_INITIAL_AMOUNT;

  switch (action.type) {
    case TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case TXN_COUNT_AMOUNT_SUMMARY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TXN_COUNT_AMOUNT_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
